import Filters from "./components/Filters";

window.addEventListener('DOMContentLoaded', () => {
    const filters = new Filters();
    filters.init();
    filters.searchFieldEvents();
});
